import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';

const CustomSelect = ({ value, onChange, options, disabled, title, placeholder }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const selected = options.find(o => o.value === value);

  return (
    <div className="relative w-full" ref={ref}>
      <button
        type="button"
        title={title}
        onClick={() => !disabled && setOpen(v => !v)}
        className={`w-full flex items-center justify-between px-3 py-2 border border-gray-600 rounded-lg text-left transition-colors ${
          disabled
            ? 'bg-black text-gray-400 cursor-not-allowed'
            : 'bg-black text-white hover:border-red-500 cursor-pointer'
        }`}
      >
        <span>{selected?.label ?? placeholder ?? value}</span>
        <ChevronDown
          className={`h-4 w-4 flex-shrink-0 text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && !disabled && (
        <div className="absolute left-0 top-full mt-1 z-50 w-full bg-gray-900 border border-gray-600 rounded-lg overflow-hidden shadow-lg">
          {options.map(opt => (
            <button
              key={opt.value}
              type="button"
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-2 text-sm transition-colors ${
                opt.value === value ? 'bg-red-600 text-white' : 'text-gray-300 hover:bg-gray-700'
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
